import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../dados/api.js'

/// Diz se os perfis (ou as obras) de uma pessoa seguem o RM ou foram ajustados à
/// mão — e deixa voltar a seguir o RM.
export function OrigemRm({
  usuarioId,
  tipo,
  manual,
}: {
  usuarioId: string
  tipo: 'perfis' | 'obras'
  manual: boolean
}) {
  const cliente = useQueryClient()
  const voltar = useMutation({
    mutationFn: () => api.adminSeguirRm(usuarioId, tipo === 'perfis' ? { perfis: true } : { obras: true }),
    onSuccess: () => void cliente.invalidateQueries({ queryKey: ['admin'] }),
  })
  const oQue = tipo === 'perfis' ? 'os perfis' : 'as obras'

  if (!manual) {
    return (
      <p className="mt-1 text-[11px] text-slate-500">
        Seguem o RM ({tipo === 'perfis' ? 'pela função' : 'pela seção'}). Alterar aqui passa a valer por cima do RM.
      </p>
    )
  }
  return (
    <p className="mt-1 flex flex-wrap items-center gap-x-2 text-[11px] text-slate-500">
      <span>Ajustados à mão: a sincronização com o RM não mexe {tipo === 'perfis' ? 'neles' : 'nelas'}.</span>
      <button
        onClick={() => voltar.mutate()}
        disabled={voltar.isPending}
        className="font-semibold text-marinho hover:underline"
        title={`Na próxima lista do RM aplicada, ${oQue} voltam a vir do RM`}
      >
        {voltar.isPending ? 'Salvando…' : 'Voltar a seguir o RM'}
      </button>
      {voltar.error && <span className="text-alta">{(voltar.error as Error).message}</span>}
    </p>
  )
}
